import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../utils/hooks/useMutationWithError";
import { useCreateEmailVerificationProfileMutation } from "./__generated__/useCreateEmailVerificationProfileMutation.graphql";

export const useCreateEmailVerificationProfile = () => {
  const [createVerification, isCreating] =
    useMutationWithError<useCreateEmailVerificationProfileMutation>(
      userCheckPhoneProfileMutationString
    );

  const createEmailVerification = (
    email: string,
    onCompleteHandler: () => void
  ) => {
    createVerification({
      variables: { input: { email } },
      onCompleted: (res) => {
        if (res.responsePayload?.success) {
          onCompleteHandler();
        }
      },
    });
  };
  return [createEmailVerification, isCreating] as const;
};

export const userCheckPhoneProfileMutationString = graphql`
  mutation useCreateEmailVerificationProfileMutation(
    $input: CreateEmailVerificationInput!
  ) {
    responsePayload: createEmailVerification(input: $input) {
      success
      errors {
        field
        code
        message
      }
    }
  }
`;
